<template>
  <div class="sidebar">
   <ul v-if="menu">
      <li v-for="item,index in menu" :key="index">
        <a :href="item" >{{langs[index]}}</a>
      </li>
    </ul> 
  </div>
</template>

<script>
import '../assets/scss/sidebar.scss'
import axios from 'axios'
import commonProps from '../common/common.js'
import langs from '../config/langs/en.json'
const common = new commonProps
export default {
  name:'sidebarComponent',
  data() {
    return {
      menu:{},
      langs:langs
    }
  },
  mounted() {
    this.getMenuItems()

  },
  methods: {
    getMenuItems() {
      axios .get(`${common.supervisorApi}rest/woo_menu`)
            .then(result => {
            //console.log(result.data)
              if (result.data && !result.data.error) {
                this.menu = result.data.data
                this.$emit('sidebarLoaded', true);
              }
            })
    }
  }
}
</script>
